import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccountSubtitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${28 * Screen.widthRatio}px;
  line-height: ${38 * Screen.widthRatio}px;
  margin-top: ${12 * Screen.widthRatio}px;
  width: ${1000 * Screen.widthRatio}px;
`;

export default AccountSubtitle;
